class StoreLocator extends HTMLElement {

  constructor() {
    super();
    this.mobileImage = this.querySelector('[data-stockist-image-mobile]');
    this.desktopImage = this.querySelector('[data-stockist-image-desktop]');
    this.regionInputs = this.querySelectorAll('input[name="region"]');
    this.regionInputs.forEach(input => input.addEventListener('change', this.handleRegionChange.bind(this)));
    this.preloadImages();
  }
  
  handleRegionChange(event) {
    this.mobileImage.src = event.target.dataset.mobileImage;
    this.desktopImage.src = event.target.dataset.desktopImage;
  }

  preloadImages() {
    this.regionInputs.forEach(input => {
      let mobileImage = new Image();
      mobileImage.src = input.dataset.mobileImage;
      let desktopImage = new Image();
      desktopImage.src = input.dataset.desktopImage;
    })
  }

}
customElements.define('store-locator', StoreLocator);